import React from "react";
import { Download } from "lucide-react";
import { cn } from "./ui/cn";

function toCSV(rows, columns) {
  const header = columns.map((c) => JSON.stringify(c.label)).join(",");
  const lines = rows.map((row) =>
    columns
      .map((c) => {
        const val = c.value(row);
        if (val === null || val === undefined) return "";
        if (typeof val === "number") return val;
        return JSON.stringify(String(val));
      })
      .join(",")
  );
  return [header, ...lines].join("\n");
}

export default function ExportButton({
  rows,
  columns,
  filename = "export.csv",
  disabled,
  className,
}) {
  function handleExport() {
    const csv = toCSV(rows, columns);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  }

  return (
    <button
      type="button"
      onClick={handleExport}
      disabled={disabled || !rows || rows.length === 0}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-2.5 py-1 text-xs font-semibold text-slate-700 shadow-sm transition hover:border-slate-300 hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
    >
      <Download className="h-3.5 w-3.5 text-slate-500" />
      Export CSV
    </button>
  );
}
